import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';
import { DataService } from './data.service';
import { CheckPriceModel } from '../interfaces/vehicleModel';
@Injectable({
    providedIn: 'root'
  })
  export class LicenceApplicationService extends DataService{

    private url =environment.apiUrl + 'api/';
    
    constructor(private httpClient: HttpClient) { 
        super(httpClient);
        super.setBaseUrl('api/City');
     }
     
    getAllCitties(){
        return this.httpClient.get( this.url + 'City/getCities');    
    }
    getAllZonesByCityId(id:any){
        return this.httpClient.get(this.url+'Zone/getZones?cityId='+id);
    }
    getAllParentZonesByCityId(id:any){
        return this.httpClient.get(this.url+'Zone/getParentZones?cityId='+id);
    }
    getAllParkingGarages(){
        return this.httpClient.get(this.url+'ParkingGarage/getParkingGarages');
    }
    getAllPublicParkings(){
        return this.httpClient.get(this.url+'PublicParkings/getPublicParkings');
    }
    getAllParkingTypes(){
        return this.httpClient.get(this.url + 'ParkingType/getParkingTypes');
    }
     getAllParkingTypesByCityId(id:any){
        return this.httpClient.get(this.url + 'ParkingType/getParkingTypesByCityId?cityId='+id);
    }
    getAllPermitTypes(id:any , cityId :any){
        return this.httpClient.get(this.url + 'Permit/getPermitTypes?parkingTypeId='+id+'&cityId='+cityId);
    }
    sendApp(model:any){
        return this.httpClient.post(this.url+'Application/addApplication', model)
    }
    getPriceForPermit(model:any){
        return this.httpClient.post(this.url+'Application/getPriceForPermit', model);
    }
    pay(model:any){
        return this.httpClient.post(this.url+'Application/createOrder', model);
    }
    getApplicationDetalis(model:any){
        return this.httpClient.post(this.url+'Application/getApplicationDetalis', model);
    }
    checkPriceModel(model:any){
        return this.httpClient.post<CheckPriceModel>(this.url+'Application/checkPriceModel', model);
    }
   
  }